export const static_data = [
  {
    category: "Headphones",
    imgUrl: "https://assets.bose.com/content/dam/Bose_DAM/Web/consumer_electronics/global/products/headphones/soundlink_around-ear_wireless_headphones_II/product_silo_images/sl_ae_II_black_EC_hero.psd/jcr:content/renditions/cq5dam.web.1000.1000.png",
    products: [
      {
        id: 1,
        category: 'Headphones',
        subCategory: 'Over-Ear Headphones',
        name: "Bose 700 Series",
        imgUrl: "https://houseofanasa.s3.amazonaws.com/bose_700S.png",
        price: "500.00",
        description: "Bose Noise Cancelling Headphones 700 deliver everything you’d expect—and things you’d never have imagined possible. Think of them as smart headphones that let you keep your head up to the world with easy access to voice assistants. Or confidently take a call with the most powerful microphone system for voice pickup. And then there’s Bose AR*, a first-of-its-kind audio augmented reality platform that makes astonishing new audio experiences possible.",
        brand: "Bose"
      },
      {
        id: 2,
        category: 'Headphones',
        subCategory: 'Over-Ear Headphones',
        name: "SoundLink Around-Ear Wireless Headphone",
        imgUrl: "https://assets.bose.com/content/dam/Bose_DAM/Web/consumer_electronics/global/products/headphones/soundlink_around-ear_wireless_headphones_II/product_silo_images/sl_ae_II_black_EC_hero.psd/jcr:content/renditions/cq5dam.web.1000.1000.png",
        price: "269.99",
        description: "Music makes you feel free. Wires shouldn’t get in the way of that. SoundLink® wireless headphones are engineered for exceptional sound, which stays consistent at any volume thanks to a combination of exclusive technologies. With clear calls in any environment, durable materials and a comfortable fit, you can experience wireless freedom. And uncompromised performance.",
        brand: "Bose"
      },
      {
        id: 3,
        category: 'Headphones',
        subCategory: 'Over-Ear Headphones',
        name: "Beoplay H4 2nd gen",
        imgUrl: "https://images.ctfassets.net/8cd2csgvqd3m/25LWw4cyQZGJNeUaWGzGHm/442fbf0b26346054cec4bf3463d7528d/h4_black1000x1000l.png?q=90&fm=webp&w=720&h=720&fit=fill",
        price: "349.99",
        description: "Beoplay H4 deliver an authentic and a finely tuned acoustic performance based on our strong heritage of sound engineering dating back to 1925. No matter if you use Beoplay H4 wireless or corded, the music will immerse you – and let you stay in the moment.",
        brand: "Bang&Olufsen"
      },
      {
        id: 4,
        category: 'Headphones',
        subCategory: 'In-Ear Headphones',
        name: "Beoplay E8 3rd Gen",
        imgUrl: "https://images.ctfassets.net/8cd2csgvqd3m/I6h0sQ3ZAe8lJjhJ7q4WY/23a9d87ef501c3c719160029b6778748/CMS_1.png?q=90&fm=webp&w=720&h=720&fit=fill",
        price: "475.00",
        description: "The newest version of our truly wireless in-ear earphones with an improved battery life of up to 35 hours, a QI-certified wireless charging case and Bluetooth 5.1 connectivity ensure a seamless and powerful listening experience.",
        brand: "Bang&Olufsen"
      },
      {
        id: 5,
        category: 'Headphones',
        subCategory: 'In-Ear Headphones',
        name: "Beoplay H3",
        imgUrl: "https://images.ctfassets.net/8cd2csgvqd3m/Eo4XiqVTUrbiBfUvBabgu/2f44f7fd83c456e11caf3087ef4340e7/h3_black_1000x1000.png?q=90&fm=webp&w=720&h=720&fit=fill",
        price: "200",
        description: "Premium in-ear headphones for authentic sound experiences. Robust yet ultra-light, designed to fit with precision and comfort.",
        brand: "Bang&Olufsen"
      },
    ]
  },
  {
    'category': "Hifi-Audio",
    'imgUrl': "https://images.ctfassets.net/8cd2csgvqd3m/RZCYJgQK4z8lOwjQFx11v/c3a0f6317b766ea9d909e28c05f9d602/beolab-20-overview5.png?q=90&fm=webp&w=480&h=480&fit=fill",
    'products': [
      {
        id: 6,
        category: 'Hifi-Audio',
        subCategory: 'Portable Speakers',
        name: "Stockwell bluetooth Speakers",
        imgUrl: "https://images.selfridges.com/is/image/selfridges/761-10044-MARSHSTOCKWELLBLK_ALT10?$PDP_M_ZOOM$&defaultImage=761-10044-MARSHSTOCKWELLBLK_M",
        price: "168.00",
        description: "the Stockwell is the smallest travel speaker made by Marshall today. This portable active stereo speaker weighs just 1.20kg, which means it’ll go wherever you want it to. Rechargeable lithium-ion batteries are built into the Stockwell, which give it 25 hours of playing time. The handy USB port also allows you to charge your devices when you’re on the go.",
        brand: "Marshall"
      },
      {
        id: 7,
        category: 'Hifi-Audio',
        subCategory: 'Portable Speakers',
        name: "Bose Portable Speakers",
        imgUrl: "https://images.selfridges.com/is/image/selfridges/761-10044-BOSPORTHOMESPK_LUXESILVER_ALT10?$PDP_M_ZOOM$&defaultImage=761-10044-BOSPORTHOMESPK_LUXESILVER_M",
        price: "405.00",
        description: "Bose portable bluetooth speaker Spacious 360° sound, powerful bass Built-in voice control Durable, water - resistant design Control with voice, touch or app Up to 12 hours battery life per charge Wi - fi® and Bluetooth® connectivity Apple Airplay 2",
        brand: "Bose"
      },
      {
        id: 8,
        category: 'Home-Audio',
        subCategory: 'Home Speakers',
        name: "Home Speaker 300 with voice control",
        imgUrl: "https://images.selfridges.com/is/image/selfridges/761-10044-BOSHOMESPK300_TRIPLEBLACK_ALT10?$PDP_M_ZOOM$&defaultImage=761-10044-BOSHOMESPK300_TRIPLEBLACK_M",
        price: "305.00",
        description: "Built-in voice assistants Play.Pause.Shuffle.All with built -in voice assistants, like the Google Assistant and Alexa, you’ll have instant access to music with just your voice as well as access to things like weather reports and news headlines, too.So, if you want to hear something, just ask.",
        brand: "Bose"
      },
      {
        id: 9,
        category: 'Hifi-Audio',
        subCategory: 'Stereo Speakers',
        name: "Beolab 18",
        imgUrl: "https://images.ctfassets.net/8cd2csgvqd3m/7Dqhqr8onqxPSejB4Ok97p/264d58cd4a5cb41c98abfcc7b128bea6/beolab-18-bronze.png?q=90&fm=webp&w=720&h=720&fit=fill",
        price: "",
        description: "4999.99",
        brand: "Bang&Olufsen"
      },
      {
        id: 10,
        category: 'Hifi-Audio',
        subCategory: 'Stereo Speakers',
        name: "Beolab 19",
        imgUrl: "https://images.ctfassets.net/8cd2csgvqd3m/60OIJAMXb2OKfzXqnMIREF/a4b71730a7bbf482f262bcdccde84952/beolab-19-natural-hero.png?q=90&fm=webp&w=720&h=720&fit=fill",
        price: "1500.00",
        description: "High-end wireless subwoofer bringing powerful bass and a unique sculptural design to your living room.",
        brand: "Bang&Olufsen"
      },
      {
        id: 11,
        category: 'Hifi-Audio',
        subCategory: 'Stereo Speakers',
        name: "Lifestyle® 650 home entertainment system",
        imgUrl: "https://assets.bose.com/content/dam/Bose_DAM/Web/consumer_electronics/global/products/speakers/ls650_page/product_silo_images/lifestyle_650_black_EC_hero.psd/jcr:content/renditions/cq5dam.web.1000.1000.png",
        price: "4,999.99",
        description: "4999.99",
        brand: "Bose"
      },
    ]
  },
  {
    'category': "Televisions",
    'imgUrl': "https://images.ctfassets.net/8cd2csgvqd3m/5GbnuCJjPm52L58QSCBupe/a274c650c173faddc4da9bda1d269a6e/eclipse-bronze.png?q=90&fm=webp&w=720&h=720&fit=fill",
    'products': [
      {
        id: 12,
        category: 'Televisions',
        subCategory: 'Smart Tvs',
        name: "Beovision Eclipse",
        imgUrl: "https://images.ctfassets.net/8cd2csgvqd3m/5GbnuCJjPm52L58QSCBupe/a274c650c173faddc4da9bda1d269a6e/eclipse-bronze.png?q=90&fm=webp&w=720&h=720&fit=fill",
        price: "6000.00",
        description: "Beovision Eclipse is a true OLED 4K HDR TV. The magic of the self-emitting OLED pixels is their ability to turn on and off individually to reproduce absolute black and infinite contrast, the most important aspects of your viewing experience.",
        brand: "Bang&Olufsen"
      },
      {
        id: 13,
        category: 'Television',
        subCategory: 'OLED Tvs',
        name: "LG 77' W9 OLED UltraHD TV",
        imgUrl: "https://images.selfridges.com/is/image/selfridges/761-10044-LGOLED77W9PLA_ALT10?$PDP_M_ZOOM$&defaultImage=761-10044-LGOLED77W9PLA_M",
        price: "10,950.00",
        description: 'The 77" W9 OLED Ultra HD 4K HDR TV is designed to blend into the wall, bringing a mesmerising experience and aesthetic in your space.A feat only possible with uniquely sophisticated LG OLED TV technology.With a brand new 2nd gen α9 with AI, OLED display for the most accurate colour range, 4K HDR and with a full Dolby Vision & Atmos you can get a full cinematic experience in your home.',
        brand: "LG"
      },
      {
        id: 14,
        category: 'Television',
        subCategory: 'QLED Tvs',
        name: "Samsung Serif TV",
        imgUrl: "https://images.selfridges.com/is/image/selfridges/5196-10209-QE49LS01RAUXXU_ALT10?$PDP_M_ZOOM$&defaultImage=5196-10209-QE49LS01RAUXXU_M",
        price: "1750.00",
        description: "The Serif is Samsung's brand new TV for 2019, giving you the best of both worlds by being incredibly stylish when off and packed with outstanding TV technologies when on. This is what we expect from Samsung QLED. Incredible picture quality meets sophisticated style. Isn’t your living room ready for something different?",
        brand: "Samsung"
      },
      {
        id: 15,
        category: 'Television',
        subCategory: 'Smart Tvs',
        name: "Samsung RU7300 Tv",
        imgUrl: "https://images.selfridges.com/is/image/selfridges/5196-10209-UE49RU7300KXXU_ALT10?$PDP_M_ZOOM$&defaultImage=5196-10209-UE49RU7300KXXU_M",
        price: "900.00",
        description: "When Samsung says 'immersive', Samsung really means immersive. The RU7300 Curved 4K TV puts you bang in the centre of the action - whether that's swords and dragons, police thrillers, or fast car games - while True 4K colour and clarity brings seriously a vibrant picture - actually, so powerful is this feature, it transforms non-4K films in 4K films. You can also control all your connected devices with One Remote Control.",
        brand: "Samsung"
      },
      {
        id: 16,
        category: 'Television',
        subCategory: '4K Ultra HD Tvs',
        name: "Philips 4k UHD Smart Tv",
        imgUrl: "https://images.selfridges.com/is/image/selfridges/R00038713_ALT10?$PDP_M_ZOOM$&defaultImage=R00038713_M",
        price: "1500.00",
        description: "With the Philips 55OLED754 4K UHD OLED smart TV, you get the true cinematic experience powered by Dolby Vision and Dolby Atmos. The brand’s Ambilight technology lights up the wall behind the screen in real time to make the drama feel deeper and the action feel bigger. Plus, the P5 Engine brings you a whole other level of visual experience that dazzles smooth motion and sharper pictures. Now, where's the remote?",
        brand: "Philips"
      },
    ]
  }
];

export const categories = [
  {
    id: 1,
    name: "Over-Ear Headphone",
    imgUrl: "https://assets.bose.com/content/dam/Bose_DAM/Web/consumer_electronics/global/products/headphones/soundlink_around-ear_wireless_headphones_II/product_silo_images/sl_ae_II_black_EC_hero.psd/jcr:content/renditions/cq5dam.web.1000.1000.png"
  },
  {
    id: 2,
    'name': "Stereo Speakers",
    'imgUrl': "https://images.ctfassets.net/8cd2csgvqd3m/RZCYJgQK4z8lOwjQFx11v/c3a0f6317b766ea9d909e28c05f9d602/beolab-20-overview5.png?q=90&fm=webp&w=480&h=480&fit=fill"
  },
  {
    id: 3,
    name: 'OLED TVs',
    imgUrl: "https://images.selfridges.com/is/image/selfridges/761-10044-LGOLED77W9PLA_ALT10?$PDP_M_ZOOM$&defaultImage=761-10044-LGOLED77W9PLA_M"
  },
  {
    id: 4,
    name: 'Portable Speakers TVs',
    imgUrl: "https://images.selfridges.com/is/image/selfridges/761-10044-BOSPORTHOMESPK_LUXESILVER_ALT10?$PDP_M_ZOOM$&defaultImage=761-10044-BOSPORTHOMESPK_LUXESILVER_M"
  },
  {
    id: 5,
    name: 'SmartWatches',
    imgUrl: "https://images.selfridges.com/is/image/selfridges/759-10001-ART5006_ALT01?$PLP_ALL$"
  },
  {
    id: 6,
    name: 'Drones',
    imgUrl: "https://images.selfridges.com/is/image/selfridges/933-10044-DJITELLOCOMBO_ALT01?$PLP_ALL$"
  },
]

export const featured = () =>{
  let result = [];
  static_data.map((obj) =>{
    return result.push(obj.products);
  });

  return result.reduce((a,b) => a.concat(b), []).slice(0,4);
}

//const watchData4 = [
//  {
//    id: 15,
//    category: 'Wearable Tech',
//    subCategory: 'Smartwatches',
//    name: "",
//    imgUrl: "",
//    price: "",
//    description: "",
//    brand: ""
//  },
//  {
//    id: 16,
//    category: 'Wearable Tech',
//    subCategory: 'Smartwatches',
//    name: "",
//    imgUrl: "",
//    price: "",
//    description: "",
//    brand: ""
//  },
//  {
//    id: 17,
//    category: 'Wearable Tech',
//    subCategory: 'Fitness Tracker',
//    name: "",
//    imgUrl: "",
//    price: "",
//    description: "",
//    brand: ""
//  },
//  {
//    id: 18,
//    category: 'Fashion Watch',
//    subCategory: 'Watch',
//    name: "",
//    imgUrl: "",
//    price: "",
//    description: "",
//    brand: ""
//  },
//];






//useEffect(() => {
//  document.getElementsByTagName('html')[0].addEventListener('click', (e) => {
//    //if (e.target.classList.contains("navbar sidebarVisible")){

//    //}
//  })

//  //add click event to the window
//  //check the class name attached to the event when it is triggered
//  //now if that classname is not among the classnames in your sidebar
//  //you trigger the action to close the sidebar
//}, []);